import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsExercismComponent } from './simple-icons-exercism.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsExercismComponent ],
    exports:      [ SimpleIconsExercismComponent ],
    bootstrap:    []
})
export class SimpleIconsExercismModule {}
